import {
  LIBREVIEW_AUTHENTICATION_REQUEST,
  LIBREVIEW_AUTHENTICATION_RECEIVE,
  LIBREVIEW_REDIRECT_URL_RECEIVE,
} from '../libreview/actions';

export const initialState = {
  authentication: {
    isFetching: false,
    isSuccessful: null,
  },
  url: {
    url: '',
    hasUrl: false,
  },
};

const authenticationReducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case LIBREVIEW_AUTHENTICATION_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case LIBREVIEW_AUTHENTICATION_RECEIVE: {
      return {
        ...state,
        isFetching: false,
        isSuccessful: payload,
      };
    }
    default:
      return state;
  }
};

const urlReducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case LIBREVIEW_REDIRECT_URL_RECEIVE: {
      return {
        ...state,
        url: payload,
        hasUrl: true,
      };
    }
    default:
      return state;
  }
};

export const reducer = (state = initialState, action) => {
  return {
    authentication: authenticationReducer(state.authentication, action),
    url: urlReducer(state.url, action),
  };
};
